<template>
    <DateRangeDialog v-if="showDateRangeDialog"
                     @hide="showDateRangeDialog = false"
                     v-model="selectedDateTimeRange" />
</template>

<script>
    import DateRangeDialog from "@/components/DateRangeDialog.vue";

    export default {
        components: {
            DateRangeDialog
        },

        computed: {
            currentDateTime() {
                return this.$store.state.currentDateTime;
            },
            startDateTime() {
                return this.$store.state.startDateTime;
            },
            endDateTime() {
                return this.$store.state.endDateTime;
            },
            showDateRangeDialog: {
                get() {
                    return this.$store.state.showDateRangeDialog;
                },
                set(newValue) {
                    this.$store.commit("setShowDateRangeDialog", newValue);
                }
            },
            selectedDateTimeRange: {
                get() {
                    if (!this.startDateTime || !this.endDateTime) {
                        return null;
                    }

                    return {
                        startDate: this.startDateTime,
                        endDate: this.endDateTime
                    };
                },
                set(newValue) {
                    if (!newValue || !newValue.startDate || !newValue.endDate) {
                        this.$store.commit("setStartDateTime", null);
                        this.$store.commit("setEndDateTime", null);
                    } else if (newValue.startDate.hasSame(newValue.endDate, "day")) {
                        this.$store.commit("setStartDateTime", null);
                        this.$store.commit("setEndDateTime", null);

                        if (newValue.startDate.hasSame(this.currentDateTime, "day")) {
                            this.$store.commit("setSelectedDateTime", null);
                        } else {
                            this.$store.commit("setSelectedDateTime", newValue.startDate);
                        }
                    } else {
                        this.$store.commit("setStartDateTime", newValue.startDate);
                        this.$store.commit("setEndDateTime", newValue.endDate);
                        this.$store.commit("setSelectedDateTime", null);
                    }
                }
            }
        }
    };
</script>
